// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4dae4f1c51a6db0a3e0d10cddadf9d6047cf1684.chunk.js";
};